<template>
  <div
    class="rfp-rr-rating-snapshot-150-or rr-rating-snapshot float-left"
    :class="{ 'rfp-rr-rating-rtl': isRightToLeftActive }"
  >
    <div class="rfp-rr-rating-snapshot-151-or rr-rating-snapshot-inner">
      <h3 class="rfp-rr-rating-snapshot-152-or rr-sub-title black">{{ headerTitle }}</h3>
      <p>{{ headerSubTitle }}</p>
      <ul>
        <li v-for="x in sortArrays(ratingBar)" :key="x.label" class="rfp-rr-rating-snapshot-153-or">
          <span class="rfp-rr-rating-snapshot-154-or" style="width: 30px; display: inline-block"
            >{{ x.label
            }}<span class="rfp-rr-rating-snapshot-star-157-or">{{ starIcon }}</span></span
          >
          <span
            class="rfp-rr-rating-snapshot-155-or rr-rating-bar-outer"
            @click="filterStars(x.label)"
          >
            <span
              class="rfp-rr-rating-snapshot-156-or rr-rating-bar-inner"
              :class="{ Enabled: x.count != 0 }"
              :style="{ width: x.Average }"
            ></span> </span
          >{{ x.count }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
/**
 * HACK:
 * This empty script is required to make nested components work in Vue 3
 * while keeping compatibility with Vue 2 intact.
 */
</script>

<script>
import eventBus from '@loreal/eventbus-js';

export default {
  name: 'rfp-ratings-rating-snapshot',
  props: {
    headerTitle: {
      type: String,
      required: true,
    },
    headerSubTitle: {
      type: String,
      required: true,
    },
    starIcon: {
      type: String,
      required: true,
    },
    ratingBar: {
      type: Array,
      required: true,
    },
    isRightToLeftActive: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    filterStars(values) {
      const filters = ['filterOne', 'filterTwo', 'filterThree', 'filterFour', 'filterFive'];

      if (isNaN(parseInt(values, 10)))
        throw new Error(
          'error/rfp-ratings-rating-snapshot#filterStars: invalid value provided for # of stars',
          values,
        );

      eventBus.emit(filters[--values]);
      this.$scrollTo('#rare-list-page');
    },
    sortArrays(a) {
      const datas = [];
      for (let i = 0; i < a.length; i++) {
        datas.push({
          label: a[i].label,
          count: a[i].count,
          Average: a[i].Average.replace(/,/g, '.'),
        });
      }
      /* istanbul ignore next */
      return datas.slice().sort((a, b) => b.label - a.label);
    },
  },
};
</script>
